module.exports = __webpack_public_path__ + "img/bg-ticket.e7faf01f.jpg";